import { Icon } from '@ps/isp-web-component-library';
import { ChevronMediumDown } from '@ps/isp-web-component-library/icons/ChevronMediumDown';
import classNames from 'clsx';
import React from 'react';

import styles from './Title.scss';

interface Props {
  isOpen?: boolean;
}

const Title: React.FC<React.PropsWithChildren<Props>> = ({ children, isOpen = false }) => (
  <div
    className={classNames(styles.titleWrapper, {
      [styles.open]: isOpen
    })}
  >
    <div>{children}</div>
    <Icon icon={ChevronMediumDown} className={styles.icon} size="x1" />
  </div>
);

export default Title;
